"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screen = exports.GlobalStyle = void 0;

var _styledComponents = require("styled-components");

/* Global Styles */
// https://www.styled-components.com/docs/api#injectglobal
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["@import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,500,700|IBM+Plex+Mono&display=swap');html{box-sizing:border-box;}*,*::before,*::after{box-sizing:inherit;}html,#root{background:#404044;}html{font-size:10px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}body{font-family:'IBM Plex Sans',Helvetica Neue,Arial,sans-serif;margin:0;color:#dcdcdc;font-size:1.4rem;line-height:1.5;}ul{margin:0;padding:0;}p{margin:0 0 0.5rem;}a{text-decoration:none;color:inherit;}button{&:focus{outline:none;}}::-webkit-input-placeholder{color:#77899E;}::-moz-placeholder{color:#77899E;}:-ms-input-placeholder{color:#77899E;}:-moz-placeholder{color:#77899E;}h1{font-size:2.2rem;margin:0;}h2{font-size:1.6rem;font-weight:600;margin:0;color:#ececec;}h3{text-transform:uppercase;font-size:1.1rem;font-weight:500;letter-spacing:2%;color:#B4B6B9;margin:2rem 0 0.5rem;}pre{border-radius:2px;padding:0.5rem 0 !important;max-width:100%;code{font-family:'IBM Plex Mono',monospace;padding:2rem;display:block;line-height:1.4;}}p > code,li > code{padding:3px 4px;background:#1e1e1e;border-radius:2px;color:#d69d85;}"]);
exports.GlobalStyle = GlobalStyle;
var sizes = {
  smEnd: '678px',
  mdStart: '679px',
  mdEnd: '992px',
  lgStart: '993px'
};
var Screen = {
  sm: "(max-width: ".concat(sizes.smEnd, ")"),
  md: "(min-width: ".concat(sizes.mdStart, ") and (max-width: ").concat(sizes.mdEnd, ")"),
  mdUp: "(min-width: ".concat(sizes.mdStart, ")"),
  lg: "(min-width: ".concat(sizes.lgStart, ")")
};
exports.Screen = Screen;